import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import React from 'react';
import CardsConfig from './config';
import FactorActionComponent from 'components/FactorActionComponent/FactorActionComponent';
import { FACTOR_ENUMS } from 'pages/RedesignDashboard/constants';
import { Link } from 'components/navigation/Link/Link';
import { useSelector } from 'react-redux';

const BureauReport = props => {
  return <Link to={'/creditReports/tabs'}>3-bureau report</Link>;
};

const actionNegativeMarkEligibility = filteredActions => {
  const containNegative = filteredActions?.some(
    action => action?.name === 'NEGATIVE_MARKS',
  );
  const containCredit = filteredActions?.some(
    action => action?.name === 'CREDIT_REPAIR_EXPERT',
  );

  if (containNegative && containCredit) {
    filteredActions = filteredActions.filter(
      action => action?.name !== 'NEGATIVE_MARKS',
    );
  }

  return filteredActions;
};

const SummaryAction = props => {
  const { delinquentTradelineCount, derogatoryTradelineCount } = props;
  const { selectedFactorGrade } = useSelector(state => ({
    selectedFactorGrade:
      state?.score1b3bFactorDial?.factor?.selectedFactorGrade,
  }));
  const summaryActions = {
    A: (
      <Label>
        Your payment history is exceptional. On-time payments are important for
        the continue growth of your credit.
      </Label>
    ),
    B: (
      <Label>
        On time payments are very important. Pay down your{' '}
        <span className="bold">
          {delinquentTradelineCount} past due accounts{' '}
        </span>{' '}
        as soon as possible. Set up automatic bill payment to ensure you do not
        miss due dates. Check negative marks on your <BureauReport /> and
        dispute errors directly with the bureaus.
      </Label>
    ),
    C: (
      <Label>
        Negative marks can stay on your credit report for 7-10 years. Take steps
        to fix your{' '}
        <span className="bold">
          {derogatoryTradelineCount} derogatory accounts
        </span>{' '}
        as soon as possible. Check negative marks on your <BureauReport /> and
        dispute errors directly with the bureaus.
      </Label>
    ),
    D: (
      <Label>
        On time payments are very important. Pay down your{' '}
        <span className="bold">
          {delinquentTradelineCount} past due accounts{' '}
        </span>
        and take steps to fix your{' '}
        <span className="bold">
          {derogatoryTradelineCount} derogatory accounts
        </span>{' '}
        as soon as possible. Check negative marks on your <BureauReport /> and
        dispute errors directly with the bureaus.
      </Label>
    ),
    F: (
      <Label>
        On time payments are very important. Pay down your{' '}
        <span className="bold">
          {delinquentTradelineCount} past due accounts{' '}
        </span>
        and take steps to fix your{' '}
        <span className="bold">
          {derogatoryTradelineCount} derogatory accounts
        </span>{' '}
        as soon as possible. Check negative marks on your <BureauReport /> and
        dispute errors directly with the bureaus.
      </Label>
    ),
    DEFAULT: (
      <Label>
        You have no payment history. Lenders like to see a record of on-time
        payments on credit accounts. Open a new account and arrange the payment
        due date to be just after your pay is deposited in your bank account.
      </Label>
    ),
  };
  return <Label>{summaryActions?.[selectedFactorGrade]}</Label>;
};

const PaymentHistoryActionsModuleView = props => {
  const {
    additionalData,
    history,
    paymentHistoryContainer,
    selectedFactor,
    eventHandler,
    config,
  } = props;

  const summaryModule = paymentHistoryContainer?.modules?.find(
    item => item?.module === 'PAYMENT_HISTORY_SUMMARY',
  );
  const delinquentTradelineCount =
    summaryModule?.additionalData?.paymentHistorySummary
      ?.delinquentTradelineCount;
  const derogatoryTradelineCount =
    summaryModule?.additionalData?.paymentHistorySummary
      ?.derogatoryTradelineCount;

  const actions = additionalData?.actions;
  let filteredActions = actions?.filter(action =>
    action?.displayArea?.includes('CREDIT_FACTOR_PAGE'),
  );

  filteredActions = actionNegativeMarkEligibility(filteredActions);

  if (filteredActions?.length < 1) {
    return <></>;
  } else {
    return (
      <FlexContainer
        className={
          'flex-column margt20 marglr48 m-marglr16 border-rad8px system_ltblue_lb025'
        }
      >
        <FlexContainer className={'flex-column margtb10 marglr12'}>
          {selectedFactor === FACTOR_ENUMS?.PAYMENT_HISTORY && (
            <Label type="Body-2 mBody-2" className={'margtb8'}>
              <SummaryAction
                delinquentTradelineCount={delinquentTradelineCount}
                derogatoryTradelineCount={derogatoryTradelineCount}
              />
            </Label>
          )}

          {selectedFactor !== FACTOR_ENUMS?.PAYMENT_HISTORY && (
            <Label type="Body-2 mBody-2">
              {config?.tips?.factors?.creditUsage?.recommendationsLinkText}.{' '}
              <Link
                className="link pointer text-underline"
                to={`/goals`}
                ariaLabel={`${config?.tips?.factors?.creditUsage?.hyperLinkText}`}
              >
                {config?.tips?.factors?.creditUsage?.hyperLinkText}
              </Link>
            </Label>
          )}

          <Row fullWidth>
            <Disclaimer className="creditFactor margT6" />
          </Row>

          {filteredActions?.map((action, index) => {
            const { image, linkPath } = CardsConfig[action?.name];
            const offer = action?.offers[0];
            return (
              <FactorActionComponent
                key={'goalAction' + index}
                name={action?.name}
                text={action?.actionCardText}
                image={image}
                url={linkPath}
                history={history}
                offerModulePosition={index + 1}
                selectedFactor={selectedFactor}
                offer={offer}
                eventHandler={eventHandler}
              />
            );
          })}
        </FlexContainer>
      </FlexContainer>
    );
  }
};

export default PaymentHistoryActionsModuleView;
